const EXCEL_MIMETYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

export const mimeTypes = {
  EXCEL: EXCEL_MIMETYPE
}

export const fileExtensions = {
  isExcel: (fileName) => /.*\.(xlsx|xls)/.test(fileName)
}

export const blobToFile = (fileName, response, mimeType) => {
  const blob = new Blob([response], { type: mimeType })
  const link = document.createElement('a')
  link.href = window.URL.createObjectURL(blob)
  link.download = fileName
  link.click()
  link.remove()
}

export const fileToBlob = (file) => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = reject
})

export const removeMimeHeader = (blob) => blob.replace('data:', '').replace(/^.+,/, '')
